/* eslint-disable jsx-a11y/anchor-is-valid */
import { AppService } from '@aperza/util';
import React from 'react';
import style from './BrandFooter.module.scss';
import { addUtmParam } from '../addUtmParam';
const brandFooters = [
    {
        title: 'アペルザ',
        url: AppService.wwwServerHost(),
        imageUrl: `${AppService.staticServerHost()}/common/images/aperza2022/red/logo.svg`,
        imageWidth: 84,
        links: [
            {
                title: '製品検索',
                url: `${AppService.wwwServerHost()}/ja/s/model/`,
            },
            {
                title: 'カタログ検索',
                url: `${AppService.wwwServerHost()}/ja/s/catalog/`,
            },
            {
                title: '通販検索',
                url: `${AppService.ecServerHost()}/ja/s/item/`,
            },
            {
                title: 'ニュース検索',
                url: `${AppService.wwwServerHost()}/ja/s/news/`,
            },
        ],
    },
    {
        title: 'アペルザTV',
        url: AppService.tvServerHost(),
        imageUrl: `${AppService.staticServerHost()}/common/images/aperza2022/red/logo_tv.svg`,
        imageWidth: 114,
        links: [
            {
                title: '動画一覧',
                url: `${AppService.tvServerHost()}/watch/ondemand/p/1`,
            },
            {
                title: '展示会取材動画',
                url: `${AppService.tvServerHost()}/search/webinar?k=%E5%B1%95%E7%A4%BA%E4%BC%9A%E3%83%AC%E3%83%9D%E3%83%BC%E3%83%88`,
            },
            {
                title: '配信予定動画',
                url: `${AppService.tvServerHost()}/upcoming`,
            },
            {
                title: 'アペルザTV ランキング',
                url: `${AppService.tvServerHost()}/search/feature?k=%E3%83%A9%E3%83%B3%E3%82%AD%E3%83%B3%E3%82%B0`,
            },
            {
                title: 'アペルザTV イベント',
                url: `${AppService.tvServerHost()}/event/event/p/1`,
            },
            {
                title: 'アペルザTV 特集',
                url: `${AppService.tvServerHost()}/event/feature/p/1`,
            },
            {
                title: 'アペルザTV アワード 2022',
                url: `https://tv.aperza.com/award/2022/`,
                target: '_blank',
            },
        ],
    },
    {
        title: 'アペルザカタログ',
        url: `${AppService.wwwServerHost()}/catalog/`,
        imageUrl: `${AppService.staticServerHost()}/common/images/aperza2022/red/logo_catalog.svg`,
        imageWidth: 164,
        links: [
            { title: 'カタログ 特集一覧', url: `${AppService.wwwServerHost()}/feature/list/` },
            { title: 'おすすめ情報', url: `${AppService.wwwServerHost()}/trends/top/` },
            { title: 'カタログ分類', url: `${AppService.wwwServerHost()}/catalog/top/` },
            { title: 'カタログ 掲載企業一覧', url: `${AppService.wwwServerHost()}/company/top/` },
            { title: 'カタログ 新着企業一覧', url: `${AppService.wwwServerHost()}/company/new/` },
            {
                title: 'カタログ 掲載依頼',
                url: `https://www.aperza.com/corp/service/aperzacatalog_guide/`,
                target: '_blank',
            },
        ],
    },
    {
        title: 'アペルザニュース',
        url: AppService.newsServerHost(),
        imageUrl: `${AppService.staticServerHost()}/common/images/aperza2022/red/logo_news.svg`,
        imageWidth: 140,
        links: [
            { title: '最新ニュース', url: `${AppService.newsServerHost()}/global_cat/gn_latest/` },
            { title: '新製品情報', url: `${AppService.newsServerHost()}/global_cat/gn_newproducts/` },
            {
                title: 'プレスリリース',
                url: `${AppService.newsServerHost()}/global_cat/gn_pressrelease/`,
            },
            { title: '展示会 / イベント', url: `${AppService.newsServerHost()}/global_cat/gn_events/` },
            {
                title: '基礎知識 / 用語集',
                url: `${AppService.newsServerHost()}/global_cat/gn_knowledge/`,
            },
            { title: 'コラム / エッセイ', url: `${AppService.newsServerHost()}/global_cat/gn_essay/` },
            {
                title: 'ゆるネタ / エンタ',
                url: `${AppService.newsServerHost()}/global_cat/gn_entertainment/`,
            },
            { title: 'IoTナビ', url: 'https://iot.aperza.com/', target: '_blank' },
        ],
    },
    {
        title: 'アペルザEC',
        url: AppService.ecServerHost(),
        imageUrl: `${AppService.staticServerHost()}/common/images/aperza2022/red/logo_ec.svg`,
        imageWidth: 113,
        links: [
            { title: '取り扱いメーカー一覧', url: `${AppService.ecServerHost()}/ja/mfr/index.html` },
            { title: '出店企業（店舗）一覧', url: `${AppService.ecServerHost()}/ja/dst/mp/index.html` },
            { title: '購買アカウント申請', url: `${AppService.orderServerHost()}/member/index.html` },
            {
                title: '出品について',
                url: `https://www.aperza.com/corp/service/aperza_sellers/`,
                target: '_blank',
            },
            {
                title: '購買アカウントに関するFAQ',
                url: `https://dx.aperza.com/help/guide/ec-buyer/5201/`,
                target: '_blank',
            },
            {
                title: '返品・キャンセルポリシー',
                url: `https://www.aperza.com/corp/term/ja/index.html`,
                target: '_blank',
            },
        ],
    },
    {
        title: 'アペルザDX',
        url: AppService.cloudServerHost(),
        imageUrl: `${AppService.staticServerHost()}/common/images/aperza2022/red/logo_dx.svg`,
        target: '_blank',
        imageWidth: 115,
        links: [
            {
                title: '顧客管理機能',
                url: `${AppService.cloudServerHost()}/customer/index.html`,
                target: '_blank',
            },
            {
                title: 'メールマーケティング機能',
                url: `${AppService.cloudServerHost()}/mail/delivery/index.html`,
                target: '_blank',
            },
            {
                title: '名刺管理機能',
                url: `${AppService.cloudServerHost()}/customer/business-card/index.html`,
                target: '_blank',
            },
            {
                title: 'コンテンツ管理機能',
                url: `${AppService.cloudServerHost()}/contents/index.html`,
                target: '_blank',
            },
            {
                title: '動画管理機能',
                url: `${AppService.cloudServerHost()}/contents/video/index.html`,
                target: '_blank',
            },
            {
                title: 'デジタル招待状機能',
                url: `${AppService.cloudServerHost()}/invitation/create.html`,
                target: '_blank',
            },
            {
                title: 'WebFAX機能',
                url: `${AppService.cloudServerHost()}/fax/documents/received/bookmarked`,
                target: '_blank',
            },
            {
                title: '電帳箱（電子帳簿保存法対応）',
                url: `${AppService.cloudServerHost()}/docbox`,
                target: '_blank',
            },
        ],
    },
];
export default function BrandFooter({ type, minified }) {
    return (React.createElement(React.Fragment, null, brandFooters.map((brand) => (React.createElement("div", { className: style.brandFooterCol, key: brand.title },
        React.createElement("div", null,
            React.createElement("a", { href: addUtmParam(brand.url, 'footer', type), target: brand.target },
                React.createElement("img", { alt: brand.title, src: brand.imageUrl, width: brand.imageWidth, height: "28" }))),
        React.createElement("div", { className: style.navTitleWrapper },
            React.createElement("a", { href: addUtmParam(brand.url, 'footer', type), target: brand.target, className: style.navTitle }, brand.title)),
        !minified && (React.createElement(React.Fragment, null,
            React.createElement("hr", { className: style.navDivider }),
            React.createElement("ul", { className: style.navList }, brand.links.map((item) => (React.createElement("li", { className: style.navItem, key: item.title.toString() },
                React.createElement("a", { className: style.navLink, target: item.target, href: item.url ? addUtmParam(item.url, 'footer', type) : '#' }, item.title))))))))))));
}
